import { render, staticRenderFns } from "./TrendingTweet.vue?vue&type=template&id=356d4bf6&scoped=true&"
import script from "./TrendingTweet.vue?vue&type=script&lang=js&"
export * from "./TrendingTweet.vue?vue&type=script&lang=js&"
import style0 from "./TrendingTweet.vue?vue&type=style&index=0&id=356d4bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d4bf6",
  null
  
)

export default component.exports